export default "assets/images/icons/glass-b8115ca9.svg";